import { TiersType } from '@core-lib/enums';
import { IAutocompleteData, ITierPersonneMoraleForm, ITiers, ITiersPersonnePhysiqueForm, IUser } from '@core-lib/models';
import { formatDate } from './utils.function';

export function extractTiersToAutocompleteItemsForApiSearch(
	tiersList: ITiers[] | ITiersPersonnePhysiqueForm[] | ITierPersonneMoraleForm[], 
	properties: Array<keyof ITiers> = ['nom', 'prenom']
): IAutocompleteData[] {
	return tiersList.map(tiers => {
		let complementLabel = tiers?.complementLabel;
			if (typeof complementLabel === 'undefined') {
				complementLabel = '';
			}
		if (tiers.type === TiersType.PersonnePhysique) {
			let nom = properties?.includes('nom') ? tiers?.nom?.toLocaleUpperCase() : '';
			if (typeof nom === 'undefined') {
				nom = '';
			}
			let prenom = properties?.includes('prenom') ? tiers?.prenom : '';
			if (typeof prenom === 'undefined') {
				prenom = '';
			}
			
			return <IAutocompleteData>{
				label: `${nom} ${prenom} ${complementLabel}`,
				value: tiers,
				disabled: tiers?.disabled
			};
		}
		return <IAutocompleteData>{
			label: tiers?.formeJuridique ? `${tiers?.formeJuridique + ' ' + tiers?.libelle + ' ' + complementLabel} ` : `${tiers?.libelle + ' ' + complementLabel}`,
			value: tiers,
			disabled: tiers?.disabled
		};
	});
}

export function extractTiersToAutocompleteItemsForInternalSearch(
	tiersList: ITiers[],
	properties: Array<keyof ITiers> = ['nom', 'prenom']
): IAutocompleteData[] {
	return tiersList.map(tiers => {
		if (tiers.type === TiersType.PersonnePhysique) {
			let nom = properties?.includes('nom') ? tiers?.nom?.toLocaleUpperCase() : '';
			if (typeof nom === 'undefined') {
				nom = '';
			}
			let prenom = properties?.includes('prenom') ? tiers?.prenom : '';
			if (typeof prenom === 'undefined') {
				prenom = '';
			}
			let dateNaissance = properties?.includes('dateNaissance') ? formatDate(tiers?.dateNaissance) : '';
			if (typeof dateNaissance === 'undefined') {
				dateNaissance = '';
			}

			return <IAutocompleteData>{
				label: `${nom} ${prenom} ${dateNaissance}`,
				value: tiers
			};
		}
		return <IAutocompleteData>{
			label: tiers?.formeJuridique ? `${tiers?.formeJuridique + ' ' + tiers?.libelle}` : `${tiers?.libelle}`,
			value: tiers
		};
	});
}

export function mapToAutocompleteItems<T>(items: T[], labelParam: string, valueParam: string): IAutocompleteData[] {
	return items.map(item => {
		return <IAutocompleteData>{
			label: item[labelParam] ?? '',
			value: item[valueParam] ?? ''
		};
	});
}

export function extractUserToAutocompleteItemsForApiSearch(
	userList: IUser[],
	properties: Array<keyof IUser> = ['nom', 'prenom']
): IAutocompleteData[] {
	return userList?.map(user => {
		let nom = properties.includes('nom') ? user?.nom.toLocaleUpperCase() : '';
		if (typeof nom === 'undefined') {
			nom = '';
		}
		let prenom = properties?.includes('prenom') ? user?.prenom : '';
		if (typeof prenom === 'undefined') {
			prenom = '';
		}
		return <IAutocompleteData>{
			label: `${nom} ${prenom}`,
			value: user?.id
		};
	});
}
